import throttle from 'lodash.throttle';

const trackingFunction = throttle(() => {
  const elList = document.querySelectorAll('[dataorder]');
  const campid = document.querySelector('[dataid]').getAttribute('dataid');
  const scroll = window.scrollY || window.pageYOffset;
  const viewport = {
    top: scroll,
    bottom: scroll + window.innerHeight,
  };

  elList.forEach((el) => {
    const order = el.getAttribute('dataorder');
    const datatype = el.getAttribute('datatype');

    const elTop = el.getBoundingClientRect().top + scroll;

    const elPosition = {
      top: elTop,
      bottom: elTop + el.clientHeight,
    };
    if (!el.getAttribute('data-view')) {
      if ((elPosition.bottom >= viewport.top && elPosition.bottom <= viewport.bottom)
      || (elPosition.top <= viewport.bottom && elPosition.top >= viewport.top)) {
        el.setAttribute('data-view', 'true');

        window.ua(
          'trackStructEvent',
          'campaigns',
          'campaign_component_view',
          `${campid}`,
          `${order} - ${datatype}`,
          elList.length,
        );
      }
   }
  });
}, 2000);


export default trackingFunction;
